import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import url from 'url';
import get from 'lodash/get';
import identity from 'lodash/identity';
import pickBy from 'lodash/pickBy';
import React, { useMemo, useState } from 'react';
import Helmet from 'react-helmet';
import { FormattedDate, FormattedMessage, defineMessages } from 'react-intl';
import { useSelector } from 'react-redux';
import { NavLink } from 'react-router-dom';
import styled from 'styled-components';
import * as ApiActions from 'actions/api';
import downloadIcon from 'assets/Challenges/download_icon.svg';
import sharingSrc from 'assets/Challenges/personal-challenge.jpg';
import logo_src from 'assets/Home/header__logo.svg';
import preview from 'assets/ScratchPrize/scratch_prize.jpg';
import phone from 'assets/ScratchPrize/scratch_prize_phone.png';
import Button from 'components/Button';
import { media } from 'components/responsive';
import analytics from 'utils/analytics';
import { makeProfileSelector } from 'selectors/invites';
import About from '../components/About';
import DesktopView from '../components/DesktopView';
import HowItWorks from '../components/HowItWorks';
import Join from '../components/Join';
import Popup from '../components/Popup';
import { useInviteEssentials } from '../utils/inviteEssentials';
const messages = defineMessages({
    // Mobile
    mobileTitle: ' is inviting you to Sweatcoin. Join before {deadline} and take part in the launch week prize draw!',
    titleWithoutDeadline: ' is inviting you to Sweatcoin. Join and take part in the launch week prize draw!',
    mobileButtonTitle: 'Install Sweatcoin App',
    joinButtonTitle: 'Find Out More',
    // Desktop
    desktopTitle: 'Grab your phone!',
    desktopDescription: 'You need to open the invitation link on your mobile device. Please copy the link or scan the QR code with your phone.',
    desktopButtonTitle: 'Copy the Link',
    copyButtonTitle: 'Link copied',
    // How it works
    howItWorksTitle: 'How it works',
    step_1: 'Download the sweatcoin app.',
    step_2: 'To win something cool, invite your friends to download too.',
    step_3: "When your friend registers for Sweatcoin you'll be able to scratch the prize draw ticket to reveal what you've won.",
    // Popup
    popupTitle: 'Download and win prizes!',
    popupDescription: 'Prize draw active for a limited time only, download now!',
});
// eslint-disable-next-line @typescript-eslint/no-unsafe-return
const prizedrawDeadlineSelector = (state) => get(state, 'meta.prizedraw_deadline');
const ScratchPrize = (props) => {
    const { match, location } = props;
    const { params } = match;
    const [isPopupVisible, setPopupVisible] = useState(false);
    // Profile & meta
    const profileSelector = useMemo(makeProfileSelector, []);
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return, @typescript-eslint/no-unsafe-assignment
    const profile = useSelector((state) => profileSelector(state, params));
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const prizedrawDeadline = useSelector(prizedrawDeadlineSelector);
    const deadline = prizedrawDeadline ? new Date(prizedrawDeadline * 1000) : null;
    const { linkData: { linkQuery, getCopyLink, getRedirectLink }, tracking: { channel, campaign, feature, platform }, buttonsRefs: [topButton, bottomButton], config: { origin }, } = useInviteEssentials({
        owner: profile,
        deeplink_path: `/sf/${(profile === null || profile === void 0 ? void 0 : profile.username) || ''}`,
        feature: 'scratch_prize_invite',
    });
    const pageLink = `${origin}${location.pathname}${location.search}`;
    const absoluteSharingUrl = url.resolve(origin, sharingSrc);
    return (_jsxs(Section, { children: [_jsx(Helmet, { meta: [
                    { name: 'event-id', content: 'scratch-prize-page' },
                    { name: 'event-params', content: { page_type: 'invite_page', inviter_id: profile === null || profile === void 0 ? void 0 : profile.id } },
                    { property: 'og:image', content: absoluteSharingUrl },
                ], link: [
                    { rel: 'image_src', href: absoluteSharingUrl },
                    {
                        rel: 'stylesheet',
                        href: 'https://fonts.googleapis.com/css2?family=Inter:wght@400;500;700&display=swap',
                    },
                ] }), isPopupVisible ? _jsx(Popup, { onClickHandler: setPopupVisible, messages: messages }) : null, _jsxs(Container, { children: [_jsx(StyledNavLink, { to: "/", exact: true, children: _jsx(Logo, { id: "box-logo", src: logo_src }) }), _jsx(DesktopView, { qrCodeLink: getCopyLink(), pageLink: pageLink, phone: phone, messages: messages }), _jsxs(MobileView, { children: [deadline ? (_jsx(FormattedMessage, Object.assign({}, messages.mobileTitle, { values: {
                                    deadline: (_jsx(FormattedDate, { value: deadline, day: "numeric", month: "long", year: "numeric", hour: "numeric", minute: "numeric" })),
                                }, children: (title) => (_jsxs(Title, { children: [_jsx("span", { children: (profile === null || profile === void 0 ? void 0 : profile.fullname) || (profile === null || profile === void 0 ? void 0 : profile.username) }), "\u00A0", title] })) }))) : (_jsx(FormattedMessage, Object.assign({}, messages.titleWithoutDeadline, { children: (title) => (_jsxs(Title, { children: [_jsx("span", { children: (profile === null || profile === void 0 ? void 0 : profile.fullname) || (profile === null || profile === void 0 ? void 0 : profile.username) }), "\u00A0", title] })) }))), linkQuery ? (_jsx(FormattedMessage, Object.assign({}, messages.mobileButtonTitle, { children: (title) => (_jsx(StyledButton, { title: title, ref: topButton, link: linkQuery.link, onClick: handleClick, children: _jsx(DownloadIcon, { src: downloadIcon }) })) }))) : null, _jsx(Preview, { src: preview, onClick: () => setPopupVisible(true) }), _jsx(HowItWorks, { messages: messages }), _jsx(About, {}), _jsx(Join, { children: linkQuery ? (_jsx(FormattedMessage, Object.assign({}, messages.joinButtonTitle, { children: (title) => (_jsx(JoinButton, { title: title, ref: bottomButton, link: linkQuery.link, onClick: handleClick })) }))) : null })] })] })] }));
    function handleClick(event) {
        event.preventDefault();
        void analytics.track('ScratchPrizePage', 'redirect', pickBy({
            app_link: `/sf/${(profile === null || profile === void 0 ? void 0 : profile.username) || ''}`,
            origin,
            channel,
            platform,
            feature,
            campaign,
        }, identity));
        window.location = getRedirectLink();
    }
};
/* eslint-disable */
ScratchPrize.fetchData = async ({ match: { params } }, { dispatch }) => {
    return await dispatch(ApiActions.searchUserByUsernameWithPrizedrawDeadline(params.username));
};
/* eslint-enable */
const Section = styled.section `
  position: relative;
  z-index: 1;
  overflow: hidden;
  min-height: 100vh;
  background: linear-gradient(122deg, #578cdb 0%, hsl(225, 69%, 28%) 100%);
`;
const Container = styled.div `
  position: relative;
  padding: 30px 0;
  margin: 0 auto;

  ${media.tablet `
    padding: 30px 0;
    width: 700px;
    display: block;
  `};

  ${media.desktop `
    width: 1000px;
  `};

  ${media.desktop_medium `
    width: 1200px;
  `};
`;
const StyledNavLink = styled(NavLink) `
  display: block;
  padding: 0 16px;
`;
const Logo = styled.img `
  position: relative;
  width: 150px;

  ${media.tablet `
    width: 239px;
  `};
`;
const MobileView = styled.div `
  display: flex;
  flex-direction: column;

  ${media.tablet `
    display: none;
  `};
`;
const Title = styled.h1 `
  font-family: 'Inter', sans-serif;
  font-weight: bold;
  color: #ffffff;
  font-size: 28px;
  letter-spacing: -0.2px;
  line-height: 1.3;
  font-style: normal;
  margin-top: 20px;
  margin-bottom: 24px;
  padding: 0 16px;
  word-wrap: break-word;

  span:first-of-type {
    background-color: rgba(0, 20, 48, 0.3);
    padding: 0 3px;
  }
`;
const StyledButton = styled(Button) `
  width: calc(100% - 32px) !important;
  margin: 0 16px;
`;
const DownloadIcon = styled.img `
  width: 18px;
  display: inline-block;
  margin-right: 8px;
`;
const JoinButton = styled(StyledButton) `
  background-color: rgba(255, 255, 255, 0.3);
  color: #ffffff !important;
`;
const Preview = styled.img `
  margin: 24px 16px 0;
  width: calc(100% - 32px);
  height: auto;
  display: block;
  border-radius: 16px;
`;
export default ScratchPrize;
